'use client';

import { Radio, RadioList, View } from '@bytel/trilogy-react-ts';

import { Connectivity, PlanType } from '@app-types/product';

import SharedSticker from '@components/shared-sticker';

import { useHome } from '@landing/hooks';

export function DataList({
    plans,
    isMobileFirst,
}: Readonly<{
    plans: PlanType[];
    isMobileFirst: boolean;
}>) {
    const {
        selectedPlan,
        selectedOption,
        setSelectedPlan,
        temporarilySelectedPlan,
        setSelectedNetwork,
        setTemporarilySelectedPlan,
    } = useHome();
    const baseProduct = isMobileFirst ? selectedPlan : temporarilySelectedPlan;

    const onChange = (plan: PlanType) => {
        if (plan.option5g && Object.values(plan.option5g).length === 0) {
            setSelectedNetwork(Connectivity.FIVE_G);
        } else if (!selectedOption) {
            setSelectedNetwork(Connectivity.FOUR_G);
        }
        if (isMobileFirst) {
            setSelectedPlan(plan);
        } else {
            setTemporarilySelectedPlan(plan);
        }
    };
    const sortedPlans = [...plans]?.sort((a, b) => a.dataSize - b.dataSize);

    return (
        <RadioList isMobile className='byou-radios offers'>
            {sortedPlans.map((plan) => {
                const isSelected = baseProduct
                    ? plan.gencode === baseProduct?.gencode
                    : plans?.find((plan) => plan.isHighlighted)?.gencode === plan.gencode;

                return (
                    <View className='radio-wrapper' key={plan.gencode}>
                        {plan.radioFlag ? (
                            <div className='radio-flag'>
                                <SharedSticker radioFlagColor={plan.radioFlagColor}>{plan.radioFlag}</SharedSticker>
                            </div>
                        ) : null}
                        <Radio
                            onChange={() => onChange(plan)}
                            label={plan.dataEnvelope}
                            checked={isSelected}
                            horizontalTile
                            tile
                            value={plan.gencode}
                            id={plan.gencode}
                        />
                    </View>
                );
            })}
        </RadioList>
    );
}
